<template>
  <wrapper class="flex flex-col">
    <div class="min-w-full">
      <div class="flex flex-row flex-grow relative" >
        <textarea
          aria-label="Add comment"
          ref="input"
          :value="value"
          @input="updateValue($event.target.value)"
          class="min-h-full h-40 bg-primary-light placeholder-white flex-grow overflow-hidden py-2 px-4 outline-none border-none text-white resize-none "
          :placeholder='placeholderText'
        />
      </div>
    </div>
  </wrapper>
</template>

<script>
import Wrapper from "./Wrapper";

export default {
  components: {
    Wrapper
  },
  props: {
    value: {
      type: String
    },
    placeholderText: {
      type: String,
      default: "Describe the changes that is being reviewed"
    }
  },
  methods: {
    updateValue(value) {
      this.$refs.input.value = value;
      this.$emit('input', value)
    }
  }
}
</script>

